<template>
  <div class="modal product-modal">
    <div class="overlay" @click="closeModal"></div>
    <div class="wrapper">
      <div class="container">
        <div class="form">
          <div class="form-wrapper">
            <img class="close" @click="closeModal" src="@/images/close.svg" />
            <div class="product-modal-top">
              <div class="text-container">
                <div class="text">
                  <div class="title">{{ $t("OFFER DETAILS") }}</div>
                  <div class="details-container">
                    <div class="detail-row">
                      <div class="detail-label">{{ $t("Skin name") }}</div>
                      <div class="detail-value">{{ orderToView.title }}</div>
                    </div>
                    <div class="detail-row">
                      <div class="detail-label">{{ $t("Quality") }}</div>
                      <div class="detail-value">{{ orderToView.quality }}</div>
                    </div>
                    <div class="detail-row">
                      <div class="detail-label">{{ $t("Desired Price") }}</div>
                      <div class="detail-value">
                        <b
                          >{{ orderToView.user_price }}
                          {{ orderToView.currency }}</b
                        >
                      </div>
                    </div>
                    <div class="detail-row our-price">
                      <div class="detail-label">{{ $t("Our price") }}</div>
                      <div class="detail-value">
                        <b v-if="orderToView.service_price">
                          {{ orderToView.service_price }}
                          {{ orderToView.currency }}
                        </b>
                        <span v-else class="no-offer">{{
                          $t("No offer yet")
                        }}</span>
                      </div>
                    </div>
                  </div>
                  <transition name="slide">
                    <div v-if="error" class="error-desc desc red">
                      {{ error }}
                    </div>
                  </transition>
                  <div class="buttons" v-if="orderToView.status === 'offer'">
                    <button
                      class="button"
                      @click="decline"
                      :disabled="isLoading"
                    >
                      <span v-if="!isLoading">{{ $t("Decline") }}</span>
                      <Spinner v-else />
                    </button>
                    <button
                      class="button dark"
                      @click="accept"
                      :disabled="isLoading"
                    >
                      <span v-if="!isLoading">{{ $t("Accept") }}</span>
                      <Spinner v-else />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Spinner from "@/components/shared/Spinner.vue";

export default {
  name: "OfferDetailsModal",
  props: ["orderToView"],
  components: {
    Spinner,
  },
  data() {
    return {
      isLoading: false,
      error: "",
    };
  },
  methods: {
    ...mapActions("modals", ["closeOfferDetailsModal"]),
    ...mapActions("offer", ["acceptOffer", "declineOffer"]),
    closeModal() {
      this.closeOfferDetailsModal();
    },
    async handleApiCall(action, successMessage) {
      if (this.isLoading) return;
      this.isLoading = true;
      this.error = "";

      try {
        await action(this.orderToView.id);
        this.closeModal();
      } catch (err) {
        this.error = err;
      } finally {
        this.isLoading = false;
      }
    },
    decline() {
      this.handleApiCall(this.declineOffer, "Offer declined successfully.");
    },
    accept() {
      this.handleApiCall(this.acceptOffer, "Offer accepted successfully.");
    },
  },
  watch: {
    orderToView() {
      this.error = "";
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.product-modal .wrapper .text-container {
  padding-top: 60px;
}
.details-container {
  margin: 0 auto;
  padding: 20px;
  width: 100%;
  max-width: 400px;
}
.detail-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #3c3a3e;
}
.our-price {
  padding: 16px;
  border-radius: 6px;
  border: 1px solid #626165;
  background-color: rgba(98, 97, 101, 0.1);
  margin-top: 12px;
}
.detail-label {
  font-size: 14px;
  color: #88868d;
  font-weight: 400;
}
.detail-value {
  font-size: 14px;
  color: #fff;
  font-weight: 500;
}
.no-offer {
  color: #88868d;
  font-style: italic;
}
.product-modal .wrapper .buttons {
  justify-content: center;
}
</style>
